import "./jquery-global.js";
import $ from "jquery";
import "bootstrap";


import "./custom.js";

import "./modules/vanilla-lazyload/vanilla-lazyload.js";
import "./modules/hero-slider/hero-slider.js";
import "./modules/news-slider/news-slider.js";
import "./modules/content-gallery/content-gallery.js";
import "./modules/menu/mmenu.js";
import "./modules/product-calculator/product-calculator.js";
import "./modules/faq/faq.js";



